import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material/styles'; 
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: theme => theme.palette.mode === 'light' ? '#D4AF37' : '#9333EA' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, ${alpha('#D4AF37', 0.08)} 0%, ${alpha('#9333EA', 0.05)} 30%, ${alpha(theme.palette.primary.light, 0.1)} 60%, transparent 100%)`
    : `linear-gradient(135deg, ${alpha('#D4AF37', 0.12)} 0%, ${alpha('#9333EA', 0.08)} 30%, ${alpha(theme.palette.primary.dark, 0.2)} 60%, transparent 100%)`,
  flexDirection: 'row-reverse',
  padding: '16px 20px',
  borderRadius: '12px 12px 0 0',
  border: theme.palette.mode === 'light'
    ? `1px solid ${alpha('#D4AF37', 0.2)}`
    : `1px solid ${alpha('#9333EA', 0.3)}`,
  borderBottom: 'none',
  position: 'relative',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'light'
      ? `linear-gradient(90deg, ${alpha('#D4AF37', 0.02)} 0%, ${alpha('#9333EA', 0.01)} 100%)`
      : `linear-gradient(90deg, ${alpha('#D4AF37', 0.03)} 0%, ${alpha('#9333EA', 0.02)} 100%)`,
    pointerEvents: 'none',
  },
  '&:hover': {
    backgroundColor: theme.palette.mode === 'light'
      ? `linear-gradient(135deg, ${alpha('#D4AF37', 0.12)} 0%, ${alpha('#9333EA', 0.08)} 30%, ${alpha(theme.palette.primary.light, 0.15)} 60%, transparent 100%)`
      : `linear-gradient(135deg, ${alpha('#D4AF37', 0.15)} 0%, ${alpha('#9333EA', 0.12)} 30%, ${alpha(theme.palette.primary.dark, 0.25)} 60%, transparent 100%)`,
    borderColor: theme.palette.mode === 'light' ? alpha('#D4AF37', 0.4) : alpha('#9333EA', 0.5),
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    color: theme.palette.mode === 'light' ? '#B8860B' : '#A855F7',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1.5),
    fontWeight: 600,
    letterSpacing: '0.3px',
  },
}));

export const CardStyle = styled('div')(({ theme, sx }) => ({
  boxShadow: theme.palette.mode === 'light' 
    ? `0px 8px 32px ${alpha('#D4AF37', 0.15)}, 0px 4px 16px ${alpha(theme.palette.primary.main, 0.08)}` 
    : `0px 8px 32px ${alpha('#9333EA', 0.2)}, 0px 4px 16px ${alpha('#000000', 0.3)}`,
  borderRadius: '12px',
  display: 'flex',
  justifyContent: 'center',
  background: theme.palette.mode === 'light' 
    ? `linear-gradient(145deg, #ffffff 0%, ${alpha('#F8FAFC', 0.8)} 100%)` 
    : `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${alpha('#1E293B', 0.9)} 100%)`,
  border: theme.palette.mode === 'light'
    ? `1px solid ${alpha('#D4AF37', 0.2)}`
    : `1px solid ${alpha('#9333EA', 0.3)}`,
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'light'
      ? `linear-gradient(135deg, ${alpha('#D4AF37', 0.03)} 0%, ${alpha('#9333EA', 0.02)} 100%)`
      : `linear-gradient(135deg, ${alpha('#D4AF37', 0.05)} 0%, ${alpha('#9333EA', 0.03)} 100%)`,
    pointerEvents: 'none',
  },
  '&:hover': {
    transform: 'translateY(-1px) scale(1.01)',
    boxShadow: theme.palette.mode === 'light'
      ? `0px 16px 48px ${alpha('#D4AF37', 0.25)}, 0px 8px 24px ${alpha(theme.palette.primary.main, 0.12)}`
      : `0px 16px 48px ${alpha('#9333EA', 0.3)}, 0px 8px 24px ${alpha('#000000', 0.4)}`,
    borderColor: theme.palette.mode === 'light' ? '#D4AF37' : '#9333EA',
  },
  ...sx,
}));
export const GradientStyle = styled('div')(({ theme, sx }) => ({
  height: '100%',
  background: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, ${alpha('#D4AF37', 0.12)} 0%, ${alpha('#9333EA', 0.08)} 30%, ${alpha(theme.palette.primary.light, 0.1)} 60%, transparent 100%)`
    : `linear-gradient(135deg, ${alpha('#D4AF37', 0.15)} 0%, ${alpha('#9333EA', 0.12)} 30%, ${alpha(theme.palette.primary.dark, 0.2)} 60%, transparent 100%)`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'light'
      ? `radial-gradient(circle at 20% 30%, ${alpha('#D4AF37', 0.06)} 0%, transparent 40%), radial-gradient(circle at 80% 70%, ${alpha('#9333EA', 0.04)} 0%, transparent 40%)`
      : `radial-gradient(circle at 20% 30%, ${alpha('#D4AF37', 0.08)} 0%, transparent 40%), radial-gradient(circle at 80% 70%, ${alpha('#9333EA', 0.06)} 0%, transparent 40%)`,
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(45deg, ${alpha('#D4AF37', 0.02)} 25%, transparent 25%), linear-gradient(-45deg, ${alpha('#9333EA', 0.02)} 25%, transparent 25%)`,
    backgroundSize: '60px 60px',
    pointerEvents: 'none',
    opacity: 0.3,
  },
  ...sx,
}));
  

export const IconifyLink = styled('a')(({ theme }) => (
    {
        textDecoration: 'none',
        cursor: "pointer",
        color: theme.palette.primary.main,
    }
));

export const BlankLink = styled('a')(({ theme, selected }) => (
    {
        textDecoration: selected ? 'underline' : 'none',
        cursor: "pointer",
        color: selected ? theme.palette.primary.main : theme.palette.text.primary,
    }
));

export const BackgroundImageStyle = styled('div')(({ theme, sx }) => (
    {
        ...sx,
        display: 'flex',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }
));

export const ToggleButton = styled('div')(({ theme, selected }) => ({
  padding: '14px 0',
  textAlign: 'center',
  borderRadius: '12px',
  width: '100%',
  background: selected 
    ? `linear-gradient(135deg, #D4AF37 0%, #B8860B 50%, #9333EA 100%)`
    : theme.palette.mode === 'light' 
      ? `linear-gradient(145deg, #ffffff 0%, ${alpha('#F8FAFC', 0.9)} 100%)` 
      : `linear-gradient(145deg, ${theme.palette.grey[800]} 0%, ${alpha('#1E293B', 0.9)} 100%)`,
  cursor: 'pointer',
  color: selected 
    ? 'white' 
    : theme.palette.text.primary,
  boxShadow: selected
    ? `0px 12px 32px ${alpha('#D4AF37', 0.3)}, 0px 4px 16px ${alpha('#9333EA', 0.2)}`
    : `0px 4px 12px ${alpha(theme.palette.grey[500], 0.08)}`,
  border: selected
    ? 'none'
    : `1px solid ${theme.palette.mode === 'light' ? alpha('#D4AF37', 0.2) : alpha('#9333EA', 0.3)}`,
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  fontWeight: selected ? 700 : 600,
  letterSpacing: selected ? '0.5px' : '0.2px',
  '&::before': selected ? {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: `linear-gradient(90deg, transparent, ${alpha('#ffffff', 0.2)}, transparent)`,
    animation: 'shimmer 2s infinite',
  } : {},
  '&:hover': {
    transform: 'translateY(-3px) scale(1.02)',
    boxShadow: selected
      ? `0px 16px 40px ${alpha('#D4AF37', 0.4)}, 0px 8px 24px ${alpha('#9333EA', 0.25)}`
      : `0px 8px 20px ${alpha(theme.palette.grey[500], 0.15)}`,
  },
  '@keyframes shimmer': {
    '0%': { left: '-100%' },
    '100%': { left: '100%' },
  },
}));

export const SelectStyle = styled('select')(({ theme, sx }) => ({
  outline: 'none',
  border: theme.palette.mode === 'light'
    ? `2px solid ${alpha('#D4AF37', 0.3)}`
    : `2px solid ${alpha('#9333EA', 0.4)}`,
  borderRadius: '12px',
  padding: '14px 16px',
  fontSize: '15px',
  fontWeight: 500,
  color: theme.palette.text.primary,
  background: theme.palette.mode === 'light'
    ? `linear-gradient(145deg, #ffffff 0%, ${alpha('#F8FAFC', 0.9)} 100%)`
    : `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${alpha('#1E293B', 0.9)} 100%)`,
  boxShadow: theme.palette.mode === 'light'
    ? `0px 4px 12px ${alpha('#D4AF37', 0.1)}`
    : `0px 4px 12px ${alpha('#9333EA', 0.15)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  letterSpacing: '0.2px',
  '&:focus': {
    borderColor: theme.palette.mode === 'light' ? '#D4AF37' : '#9333EA',
    boxShadow: theme.palette.mode === 'light'
      ? `0px 8px 20px ${alpha('#D4AF37', 0.2)}`
      : `0px 8px 20px ${alpha('#9333EA', 0.25)}`,
    transform: 'translateY(-2px)',
  },
  '&:hover': {
    borderColor: theme.palette.mode === 'light'
      ? alpha('#D4AF37', 0.6)
      : alpha('#9333EA', 0.7),
    transform: 'translateY(-1px)',
  },
  '& option': {
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
    padding: '8px',
  },
  ...sx,
}));

export const SearchBar = styled('div')(({ theme, sx }) => ({
  borderRadius: 16,
  display: 'flex',
  justifyContent: 'space-between',
  overflow: 'hidden',
  background: theme.palette.mode === 'light'
    ? `linear-gradient(145deg, #ffffff 0%, ${alpha('#F8FAFC', 0.95)} 100%)`
    : `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${alpha('#1E293B', 0.95)} 100%)`,
  boxShadow: theme.palette.mode === 'light'
    ? `0px 8px 24px ${alpha('#D4AF37', 0.12)}, 0px 4px 12px ${alpha(theme.palette.primary.main, 0.06)}`
    : `0px 8px 24px ${alpha('#9333EA', 0.15)}, 0px 4px 12px ${alpha('#000000', 0.2)}`,
  border: theme.palette.mode === 'light'
    ? `2px solid ${alpha('#D4AF37', 0.3)}`
    : `2px solid ${alpha('#9333EA', 0.4)}`,
  position: 'relative',
  transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'light'
      ? `linear-gradient(135deg, ${alpha('#D4AF37', 0.02)} 0%, ${alpha('#9333EA', 0.01)} 100%)`
      : `linear-gradient(135deg, ${alpha('#D4AF37', 0.03)} 0%, ${alpha('#9333EA', 0.02)} 100%)`,
    pointerEvents: 'none',
  },
  '&:focus-within': {
    transform: 'translateY(-2px)',
    boxShadow: theme.palette.mode === 'light'
      ? `0px 12px 32px ${alpha('#D4AF37', 0.2)}, 0px 8px 20px ${alpha(theme.palette.primary.main, 0.1)}`
      : `0px 12px 32px ${alpha('#9333EA', 0.25)}, 0px 8px 20px ${alpha('#000000', 0.3)}`,
    borderColor: theme.palette.mode === 'light' ? '#D4AF37' : '#9333EA',
  },
  '& input': {
    border: 'none',
    width: '100%',
    padding: '16px 20px',
    fontSize: '15px',
    fontWeight: 500,
    background: 'transparent',
    color: theme.palette.text.primary,
    letterSpacing: '0.2px',
    '&:focus, &:active': {
      outline: 'none',
    },
    '&::placeholder': {
      color: theme.palette.text.secondary,
      fontWeight: 400,
    },
  },
  '& button': {
    background: `linear-gradient(135deg, #D4AF37 0%, #B8860B 30%, #9333EA 100%)`,
    border: 'none',
    padding: '16px 24px',
    color: 'white',
    cursor: 'pointer',
    fontWeight: 700,
    letterSpacing: '0.5px',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: `linear-gradient(90deg, transparent, ${alpha('#ffffff', 0.3)}, transparent)`,
      transition: 'left 0.6s ease',
    },
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: `0px 8px 20px ${alpha('#D4AF37', 0.3)}, 0px 4px 12px ${alpha('#9333EA', 0.2)}`,
      '&::before': {
        left: '100%',
      },
    },
    '&:active': {
      transform: 'scale(0.98)',
    },
  },
  ...sx,
}));

export const RootStyle = styled('div')(({ theme, sx }) => ({
  background: theme.palette.mode === 'light'
    ? `linear-gradient(135deg, #D4AF37 0%, #B8860B 25%, ${theme.palette.primary.main} 50%, #9333EA 75%, #7C3AED 100%)`
    : `linear-gradient(135deg, #B8860B 0%, #D4AF37 25%, ${theme.palette.primary.dark} 50%, #9333EA 75%, #7C3AED 100%)`,
  display: 'flex',
  flexDirection: 'column',
  gap: '4rem',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `radial-gradient(circle at 30% 20%, ${alpha('#D4AF37', 0.15)} 0%, ${alpha('#9333EA', 0.1)} 50%, transparent 70%)`,
    pointerEvents: 'none',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `conic-gradient(from 0deg at 70% 80%, ${alpha('#D4AF37', 0.08)} 0deg, transparent 60deg, ${alpha('#9333EA', 0.06)} 120deg, transparent 180deg)`,
    pointerEvents: 'none',
  },
  ...sx,
}));

export const TableStyle = styled('table')(({ theme, sx }) => ({
  width: '100%',
  color: theme.palette.text.primary,
  borderRadius: 16,
  overflow: 'hidden',
  background: theme.palette.mode === 'light'
    ? `linear-gradient(145deg, #ffffff 0%, ${alpha('#F8FAFC', 0.9)} 100%)`
    : `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${alpha('#1E293B', 0.9)} 100%)`,
  boxShadow: theme.palette.mode === 'light'
    ? `0px 12px 40px ${alpha('#D4AF37', 0.12)}, 0px 8px 24px ${alpha(theme.palette.primary.main, 0.06)}`
    : `0px 12px 40px ${alpha('#9333EA', 0.15)}, 0px 8px 24px ${alpha('#000000', 0.2)}`,
  border: theme.palette.mode === 'light'
    ? `1px solid ${alpha('#D4AF37', 0.2)}`
    : `1px solid ${alpha('#9333EA', 0.3)}`,
  '& thead tr th': {
    borderTop: 'none',
    borderBottom: theme.palette.mode === 'light'
      ? `2px solid ${alpha('#D4AF37', 0.3)}`
      : `2px solid ${alpha('#9333EA', 0.4)}`,
    background: `linear-gradient(135deg, #D4AF37 0%, #B8860B 30%, #9333EA 100%)`,
    fontWeight: 700,
    fontSize: 15,
    color: 'white',
    verticalAlign: 'bottom',
    padding: '18px 20px',
    textAlign: 'left',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '2px',
      background: `linear-gradient(90deg, ${alpha('#ffffff', 0.3)} 0%, ${alpha('#ffffff', 0.1)} 50%, ${alpha('#ffffff', 0.3)} 100%)`,
    },
  },
  '& tbody tr': {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    '&:hover': {
      backgroundColor: theme.palette.mode === 'light'
        ? alpha('#D4AF37', 0.06)
        : alpha('#9333EA', 0.08),
      color: theme.palette.mode === 'light' ? '#B8860B' : '#A855F7',
      transform: 'scale(1.01)',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        background: theme.palette.mode === 'light'
          ? `linear-gradient(180deg, #D4AF37 0%, #9333EA 100%)`
          : `linear-gradient(180deg, #9333EA 0%, #D4AF37 100%)`,
      },
    },
  },
  '& tbody tr td': {
    background: 'transparent',
    padding: '16px 20px',
    borderBottom: `1px solid ${theme.palette.mode === 'light' ? alpha('#D4AF37', 0.1) : alpha('#9333EA', 0.15)}`,
    verticalAlign: 'middle',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    transition: 'all 0.2s ease',
  },
  '& tbody tr td img': {
    height: 48,
    borderRadius: 12,
    verticalAlign: 'middle',
    border: theme.palette.mode === 'light'
      ? `2px solid ${alpha('#D4AF37', 0.2)}`
      : `2px solid ${alpha('#9333EA', 0.3)}`,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      borderColor: theme.palette.mode === 'light' ? '#D4AF37' : '#9333EA',
    },
  },
  ...sx,
}));
export const NormalTableStyle = styled('table')(({ theme, sx }) => ({
  width: '100%',
  borderRadius: 12,
  overflow: 'hidden',
  background: alpha(theme.palette.background.paper, 0.9),
  boxShadow: `0px 4px 16px ${alpha(theme.palette.grey[500], 0.08)}`,
  border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
  '& thead tr th': {
    borderTop: 'none',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.2)}`,
    borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
    background: alpha(theme.palette.grey[100], 0.8),
    fontWeight: 600,
    fontSize: 14,
    verticalAlign: 'bottom',
    padding: '12px 16px',
    cursor: 'pointer',
    color: theme.palette.text.primary,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  },
  '& tbody tr': {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.02),
    },
  },
  '& tbody tr td': {
    padding: '10px 16px',
    borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.08)}`,
    borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.08)}`,
    verticalAlign: 'middle',
    fontSize: 13,
    color: theme.palette.text.primary,
  },
  '& tbody tr td:first-of-type, & thead tr th:first-of-type': {
    borderLeft: 'none',
  },
  '& tbody tr td img': {
    height: 40,
    borderRadius: 8,
    verticalAlign: 'middle',
  },
  ...sx,
}));
